import { Component, Inject, OnInit } from '@angular/core';
import { DialogData, InventoryOrWsreDialogComponent } from '../../inventory/inventory-or-wsre-dialog/inventory-or-wsre-dialog.component';
import { RopeShovelService } from '../../rope-shovel/rope-shovel.service';
import { NotificationsService } from 'angular2-notifications';
import { CustomerSelectItem } from '../../setup-equipment/setup-equipment.model';
import { GenericIdName } from '../../GET_NEW_UI/setup-implement/setup-implement.model';
import { GETSetupEquipmentService } from '../../GET_NEW_UI/setup-equipment/setup-equipment.service';
import { FavouriteDialogService } from '../../GET_NEW_UI/favourite-dialog/favourite-dialog.service';
import { PreferencesService } from '../../preferences/preferences.service';
import { AppService } from '../../../app.service';
import { TranslateService } from '../../../../app/translate';
import { Customer, JobSite, SelectionLists } from '../../GET_NEW_UI/entities/global/model';
import { SharedService } from '../../../../app/shared/services/SharedService';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
@Component({
  selector: 'app-inventory-report-configuration',
  templateUrl: './inventory-report-configuration.component.html',
  styleUrls: ['./inventory-report-configuration.component.scss'],
})
export class InventoryReportConfigurationComponent implements OnInit {

  userLanguage = "english";
  customerList: CustomerSelectItem[] = [];
  jobsiteList: GenericIdName[] = [];
  _dropDownLists: SelectionLists = new SelectionLists();
  _dropDownListsFiltered: SelectionLists = new SelectionLists();
  selectedCustomer: Customer;
  selectedJobsite: JobSite;
  selectedJobsiteFromHeader: JobSite = new JobSite();
  selectedJobsiteId: number;
  isLoading: boolean = false;
  //appUris: AppUris;
  customerId: number = 0;
  JobSiteId: number = 0;

  constructor(public _dialogRef: MatDialogRef<InventoryOrWsreDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData, private _reportConfigService: RopeShovelService,
    private _notify: NotificationsService, private _equipmentService: GETSetupEquipmentService,
    private _appService: AppService,
    private _translate: TranslateService,
    private _notification: NotificationsService,
    private _sharedService: SharedService,
    private _favouriteDialogService: FavouriteDialogService, private readonly _pref: PreferencesService,) { }

  ngOnInit() {
    this.loadCustomers();
    this.loadJobsitesForCustomer();
    //this._appService.getAppUris().subscribe(result => { this.appUris = result; });
  }

  loadCustomers() {
    this._appService.getCustomerListForSelection(1, 10000).subscribe(
      result => {
        this._dropDownLists.customerList = result;
        this._dropDownListsFiltered.customerList = result;
      },
      error => {
        console.error(error);
      },
      () => {
      }
    );
  }

  loadJobsitesForCustomer() {
    this._appService.getJobSiteListForSelection(1, 10000).subscribe(
      result => {
        this._dropDownLists.jobSiteList = result;
        this._dropDownListsFiltered.jobSiteList = result;
      },
      error => {
        console.error(error);
      },
      () => {

      }
    );

  }

  Translate(value: string): string {
    return this._translate.translateToLang(value, this.userLanguage);
  }

  customerChanged(event: any) {
    if (event.target.value != "") {
      const filterValue = event.target.value.toLowerCase();
      this._dropDownListsFiltered.customerList = this._dropDownLists.customerList.filter(option => option.Title.toLowerCase().includes(filterValue));
    }
  }

  onSelectCustomer(event: any) {
    let id = this._dropDownListsFiltered.customerList.find(f => f.Title == event.value).Id
    this.selectedCustomer = event.value;
    this.customerId = id;
    this._dropDownListsFiltered.jobSiteList = null;
    this._dropDownListsFiltered.jobSiteList = this._dropDownLists.jobSiteList.filter(
      m => m.CustomerId === id
    );
  }

  jobsiteChanged(event: any): void {
    this.selectedJobsite = event.value;
    if (!this.selectedJobsite) {
      return;
    }
    this.JobSiteId = this.selectedJobsite.Id;
  }

  onCloseClick(): void {
    this._dialogRef.close(false);
  }

  FleetReportPdf() {

    let data = {}
    if (this.customerId == 0 || this.JobSiteId == 0) {
      this._notification.warn('Please select customer and jobsite and try again!');
      return
    }
    this._pref.FleetReportPdf(data).subscribe(r => {
      if (r.m_Item1) {
       
      
      } 
    }, error => {
      console.error(error);
      
    });
  }

  printPDF() {
    if (this.customerId == 0 || this.JobSiteId == 0) {
      this._notification.warn('Please select customer and jobsite and try again!');
      return
    }
    //window.open(this.appUris.UCUri + '/api/Dashboard/GetInventoryReportPdf?cu=' + this.customerId + "&jb=" + this.JobSiteId  , '_blank');
    window.open(this._appService.getBaseURL() + '/api/Dashboard/GetInventoryReportPdf?cu=' + this.customerId + "&jb=" + this.JobSiteId  , '_blank');
  }
}
